module.exports = __webpack_public_path__ + "static/img/testimony (36).52646adc.jpg";